<template>
  <Modal :show="show" @update:show="(val: boolean) => emit('update:show', val)">
    <template #title><span style="font-size: 0.35rem">请先选择专题</span></template>
    <div class="content" style="display: flex; justify-content: center; align-items: center" v-if="loading">
      <van-loading />
    </div>
    <div class="content" v-else>
      <div class="title">01. 专业评审奖通道</div>
      <ContributeCard v-for="(item, i) in expertReviewList" :title="item.title" :desc="item.description"
        :rest-count="item?.restSubmitCount" @constribute="handleContribute(item, 'expertReview')" class="item"
        :class="i === expertReviewList.length - 1 ? 'last' : ''" />
      <div class="title">02. 快手人气奖通道</div>
      <ContributeCard v-for="(item, i) in kuaishouPopularity" :title="item.title" :desc="item.description" :rest-count="item?.restSubmitCount >= 0 ? item?.restSubmitCount : '无限'
        " @constribute="handleContribute(item, 'kuaishouPopularity')" class="item"
        :class="i === kuaishouPopularity.length - 1 ? 'last' : ''" />
    </div>
  </Modal>
</template>
<script setup lang="ts">
import { ref, onMounted } from "vue";
import { Loading as VanLoading } from "vant";
import ContributeCard from "../common/contributeCard.vue";
import Modal from "../common/modal.vue";
import FormModal, { FormModalProps } from "../formModal/formModal.vue";
import { ContributeCount, getContributeCount } from "../common/api/request";
import { ApiModal } from "~/composables/apiModal";
import kylogger from "@ky/sdk/dist/log/kylogger";
import { cloneDeep } from "lodash-es";
import { checkAuth } from "../checkPermission";

interface Props {
  show?: boolean;
}

type Event = {
  (e: "update:show", show: boolean): void;
};

const props = defineProps<Props>();
const emit = defineEmits<Event>();

const datas = ref<ContributeCount>();
const formModal = ref<ApiModal<typeof FormModal>>();
const actives = ref<FormModalProps["actives"]>([] as any);
const loading = ref(false);

const expertReviewList = computed(() => datas.value?.expertReview ?? []);
const kuaishouPopularity = computed(
  () => datas.value?.kuaishouPopularity ?? [],
);

const handleContribute = async (
  item: ContributeCount["expertReview"][number],
  type: "expertReview" | "kuaishouPopularity",
) => {
  kylogger.collect("CLICK", "CHOOSE_TRACK", {
    track: item.code,
  });
  await checkAuth();
  emit("update:show", false);
  actives.value = [type, item.code];
  if (!formModal.value) {
    formModal.value = new ApiModal(FormModal, {
      "onUpdate:count": (newDatas: ContributeCount) => {
        datas.value = cloneDeep(newDatas);
      },
    });
  }
  formModal.value.show({ actives: actives.value });
};

watch(() => props.show, (value) => {
  if (!value) return;
  loading.value = true;
  getContributeCount()
    .then((data) => {
      datas.value = data.data;
    })
    .catch((e) => {
      emit("update:show", false);
    })
    .finally(() => {
      loading.value = false
    });
})

onMounted(() => {
  kylogger.collect("SHOW", "CHOOSE_TRACK_POPUP", {});
});
</script>

<style scoped lang="less">
.popup-container.van-popup {
  background-color: rgba(26, 27, 34, 1);
  font-size: 0.3rem;
  color: #fff;
}
.content {
  padding: 0 0.48rem 0.8rem;
  min-height: 14.5rem;
  background-color: rgba(26, 27, 34, 1);

  @media screen and (max-width: 1360px) {
    min-height: 0;
  }

  .title {
    font-weight: 500;
    font-size: 0.3rem;
    line-height: 0.48rem;
    color: #fff;
    padding: 0.48rem 0 0.4rem;
  }

  .item {
    margin-bottom: 0.32rem;

    &.last {
      margin-bottom: 0.08rem;
    }
  }

  @media screen and (max-width: 1360px) {
    padding: 0 0.32rem 0.36rem;

    .title {
      padding: 0.32rem 0;
    }

    .item {
      margin-bottom: 0.16rem;

      &.last {
        margin-bottom: 0;
      }
    }
  }
}
</style>
